import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const settingsAPI = {
    get: async () => {
        try {
            const { data } = await api.get('/api/settings/');
            return data;
        } catch (error) {
            handleApiError(error, 'Get settings error:');
        }
    },
    
    update: async (settingsData) => {
        try {
            const { data } = await api.put('/api/settings/update/', settingsData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update settings error:');
        }
    }
}; 